import { reportProgressiveAppTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_PROGRESSIVE_APP_REPORT_FILTERS,
  RESTORE_INITIAL
} = reportProgressiveAppTypes;

const getInitialState = () => ({
  startDate: newDate(),
  endDate: newDate(),
  station: null,
});

export const reportProgressiveAppReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case SET_PROGRESSIVE_APP_REPORT_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return getInitialState();

    default:
      return state;
  }
};
